import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateFn } from '@angular/router';

export const adminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  
  const userStr = localStorage.getItem('currentUser');
  if (!userStr) {
    router.navigate(['/login']);
    return false;
  }

  const user = JSON.parse(userStr);
  if (user.role !== 'admin') {
    console.warn('❌ Accès refusé: Vous devez être administrateur');
    router.navigate(['/home']);
    return false;
  }

  return true;
};
